import { Output, EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { TemplateManagerProvider } from '../../providers/template-manager/template-manager';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../configure-service/configure-service';
import { CommunicationServiceProvider } from '../communication-service/communication-service'
import { LoadingController, ToastController } from 'ionic-angular';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { _ } from 'ag-grid-community';
import * as Rx from 'rxjs';
import { Subject } from 'rxjs';

const OBJLEN = 0;
@Injectable()
export class DriveServiceProvider {
  // private _baseUrl = 'http://localhost:8100/assets/sampledata/';
  @Output() jsonFolderData = new EventEmitter<string>();
  @Output() jsonBreadcrumbsData = new EventEmitter<string>();
  @Output() messageToEmit = new EventEmitter<string>();
  deskDummyFolderId: any = '';
  objShareCurrentFolder: any = {}
  objCurrentFolder: any = {};  // always refer to the current visible folder
  objCreatedFolder: any; //newly created folder
  objCreatedShareFolder: any;
  objRootFolder: any = {}; // referes to the rool folder
  objShareRootFolder: any; // referes to the rool folder
  objBreadCrumbs: any = []; // array of breadcrumbs in the order created
  objBreadCrumbsPath: any = {}; // store folder structure with breadcrumb id 

  objSelectedTemplate: any; // store selected template
  objStatusid: any = []; //store the progress bar traversing status(1,2,3,4)
  objFilterParams: any = []; //store the display name key of the file
  objListFile = {}; //store the list of files
  objCurrentFile: any;
  objCurrentTemplate: any;
  objCreatedSmartFolder: any;
  objGetAllTemplate: any = {};
  templateList: any = [];
  objComponentList: any = []; //store the display name key of the file 
  objUserLoginDetails: any = {};
  repeatSyncDataApi: boolean = false;
  recruitmentFlag: boolean = false;
  candidateFlag: boolean = false;
  objFolderTemplates: any[];
  CurrentFoldersData: any = [];
  CurrentFilesData: any = [];
  CurrentTemplatesData: any;
  objFileShareHeaderColprops: any = [];
  objCreatedFile: any;
  stFileNameParam: any = '';
  filterTypeData: any = [];
  ftdata: any = '';

  _http: any;
  createTemplateData: any;
  myTimesheet: any;
  internalTicketsFolder: any;
  publicTicketsFolder: any;
  mspInvoiceFolder: any;
  projectInvoiceFolder: any;
  clientFolder: any;
  staffFolder: any;
  hrModuleFolder: any;
  BasicInformationHrFolder: any;
  OfferFormHrFolder: any;
  ContractFormHrFolder: any;
  CheckHrFolder: any;
  BankFormHrFolder: any;
  TaxFormHrFolder: any;
  ReviewsHrFolder: any;
  DisciplinaryHrFolder: any;
  AppraisalFormHrFolder: any;
  ExitFormHrFolder: any;
  RecordoFormHrFolder: any;
  ReferenceHrFolder: any;
  TerminationFormHrFolder: any;
  objFolderDataResponse: any;
  pageName: any = "drive";
  activeSideMenu: any = 'Desk';
  objFolderActionPostdata: any = {};
  objCurrentParentFolder: any;
  checkcount: any = 0;
  adminAccess: boolean = false;
  adminUserid: any = {};
  public myForm: FormGroup;
  objCurrentTrackerProp: any = {};
  objDeskData: any = {};
  selectedTracker: any = {};
  selectedTrackerIndex: any = 0;
  objShareUserData: any = {};
  objMoveSourceFolder: any = {};
  componentList: any = [];
  getAllTrackerFolder: any = {};
  containerComp: any;
  driveApps: any = [];
  private instance: Rx.Subject<any>;
  //Left Side Nav bar 
  private setSideBar = new Rx.BehaviorSubject('sideBar');
  getSideBar = this.setSideBar.asObservable();
  clientAdminAccess: boolean = false;
  userId: any;
  clientAdminId: any; folderSearch: any = '';
  userAccess: boolean = false;
  userInitial: any = '';
  longinUserName: any = '';
  pushDeleteData: any;
  deleteDataIdx = 0;
  objTemplateID: any;
  current_app_name: any;
  mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  ObjCurrentAppUsers: any = [];
  LoginUserDetails: any = {};
  objBckupObjFolerProperties: any = {};
  watchTabFolderProps: any = {};
  activePageStatus: boolean = false;
  objOpenFolder: any;
  objFolderRules: any = {};
  formGridTempProps: any = {};
  gridNewForm: boolean = false;
  rowNode: any;
  appSpace: any = {};
  templateconfig: any = [];
  updateFolder: any;
  loader:any;
  headerDetail:any;
  pages: Array<{ title: string, id: any, component: any, openTab?: any, iconlogo: string, parentfolderid: any, classname: any, display: boolean }>;
  constructor(public http: Http, public datePipe: DatePipe, public storeWrap: StoreWrapProvider, public configureService: ConfigureServiceProvider, public toastController: ToastController, public templateManager: TemplateManagerProvider, public configApiService: ConfigApiServiceProvider, public communicationServ: CommunicationServiceProvider,public loadingController: LoadingController,) {
    this.objRootFolder = this.objCurrentFolder = this.storeWrap.getFolderStructure();
    // this.getTemplates(() => {
    // });
  }

  renderComponent() {
    this.gotoRootFolder();
  };

  getFolderStructure(): any {
    return this.storeWrap.getFolderStructure()
  }

  getDriveRootFolders(data, cbck) {
    this.storeWrap.pullData(0, data, null, '', this.storeWrap.typeOfData.typeRootFolder, (rootFolder) => {
      this.objRootFolder = rootFolder;
      console.log(rootFolder);
      cbck(this.objRootFolder);
    });
    // this.initDefaultValue();
  }

  getShareRootFolders(data, cbck) {
    this.storeWrap.pullData(0, data, null, '', this.storeWrap.typeOfData.typeSharedRootFolder, (sharerootFolder) => {
      if (sharerootFolder == null) {
        sharerootFolder = this.storeWrap.getFolderStructure();
        sharerootFolder['name'] = 'Share';
      }
      this.objRootFolder = sharerootFolder;
      cbck(this.objRootFolder);
    });
  }

  setShareCurrentFolder(folder) {
    this.objShareCurrentFolder = folder;
  }

  getShareCurrentFolder() {
    return this.objShareCurrentFolder;
  }

  openDrive(appInfo, callback, type = null) {
    this.storeWrap.storeTemplates = {};
    if (appInfo) {
      this.configureService.setStudio(appInfo['StudioAppCode']);
      this.configApiService.currentDriveApp = appInfo;
    }

    if (!appInfo) {
      this.configApiService.pullApiData(data => {
        this.storeWrap.pullData(0, null, this.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeTemplate, (templateData) => {
          data = { "userid": this.configureService.getLoginUserID() };
          if (type != 'share') {
            this.getDriveRootFolders(data, (rootFolder) => {
              this.objCurrentFolder = rootFolder;
              if (callback) {
                callback(rootFolder);
              }
            });
          } else if (type == 'share') {
            callback(null);
          }
        });
      })
    } else {
      this.configApiService.pullApiData(data => {
        this.storeWrap.pullData(0, null, this.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeTemplate, (templateData) => {
          data = { "userid": this.configureService.getLoginUserID() };
          if (type != 'share') {
            this.getDriveRootFolders(data, (rootFolder) => {
              this.objCurrentFolder = rootFolder;
              if (callback) {
                callback(rootFolder);
              }
            });
          } else if (type == 'share') {
            callback(null);
          }
        });
      });


    }


  }

  getRootFolder = ((rootFolder) => {
    this.objRootFolder = rootFolder;
  });

  getSharedFolder() {
    this.storeWrap.pullData(0, null, null, null, this.storeWrap.typeOfData.typeSharedRootFolder, this.getSharedRootFolder);
  }

  getSharedRootFolder = ((rootFolder) => {
    this.objRootFolder = rootFolder;
  });

  initDefaultValue(data, pageName, cbck) {
    if (cbck == null) {
      cbck = this.loadFolderData;
    }
    this.pageName = pageName;
    this.storeWrap.pullData(0, data, this.objCurrentFolder, this.storeWrap.typeOfApi.customSummary, this.storeWrap.typeOfData.typeSharedFolder, cbck);
  }

  storeComponentToLocal = ((comp) => {
  })

  loadFolderData = (data) => {
    this.objFolderDataResponse = data;
    this.objCurrentFolder['folders'] = [];
    this.objCurrentFolder['files'] = [];
    this.objCurrentFolder['template'] = [];
    this.objCurrentFolder = Object.assign({}, this.storeWrap.getFolderStructure());
    this.CurrentFilesData = [];
    for (var i = 0; i < data.length; i++) {
      if (this.pageName == 'share') {
        console.log("Index - ", i, "data - ", data)
        if (data[i]['ShareType'] == 'Folder') {
          if (data[i]['SharedFolder']) {
            this.objCurrentFolder['folders'].push(JSON.parse(data[i]['SharedFolder']));
            console.log(" this.objCurrentFolder", this.objCurrentFolder)
          } else {
            this.objCurrentFolder['folders'].push({});
            console.log(" this.objCurrentFolder", this.objCurrentFolder)
          }
        } else if (data[i]['ShareType'] == 'File') {
          if (data[i]['SharedFolder']) {
            // this.pullSyncData(this.objCurrentFolder['template'][0].id,JSON.parse(data[i]['SharedFolder']),this.objRootFolder,this.storeWrap.typeOfApi.summary,this.storeWrap.typeOfData.typeSharedFile,this.getFolderData);  
            //@ Durai Changed for When clicking drive it throws id of undefined so commented old code and removed id from that ///////////
            this.pullSyncData(this.objCurrentFolder['template'][0], JSON.parse(data[i]['SharedFolder']), this.objRootFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeSharedFile, this.getFolderData);
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  
          }
        }
      } else if (this.pageName == 'drive') {
        if (data[i]['UserFolder']) {
          this.objCurrentFolder['folders'].push(JSON.parse(data[i]['UserFolder']));
        }
      }
    }

  }

  getFolderData = (data) => {
    console.log(data);
  }

  gotoRootFolder() {
    this.objBreadCrumbsPath = {};
    this.objBreadCrumbs = [];
    this.objListFile = {};
    this.CurrentFilesData = [];
    this.objBreadCrumbs.push({ 'name': this.objRootFolder.name, id: this.objRootFolder.folder_id, level: this.objBreadCrumbs.length, fdata: this.objRootFolder });
    this.objBreadCrumbsPath[this.objRootFolder.folder_id] = this.objRootFolder;
    this.objCurrentFolder = this.objRootFolder;
    console.log(this.objCurrentFolder.folders.length)
  }


  gotoFolder(folder) {
    if (!folder) {
      this.gotoRootFolder();
    } else {
      if (folder.folders) {
        this.objBreadCrumbs.push({ 'name': folder.name, id: folder.folder_id, level: this.objBreadCrumbs.length, fdata: folder });
        this.objBreadCrumbsPath[folder.folder_id] = folder;
        this.objCurrentFolder = folder;
      }
    }
    console.log(this.objBreadCrumbs);
    // this.jsonFolderData.emit(this.objCurrentFolder);
    // this.jsonBreadcrumbsData.emit(this.objBreadCrumbs);
    return this.objCurrentFolder;
  }

  gotoBreadCrumbsFolder(folderid) {
    if (!folderid) {
      this.gotoRootFolder();
    }

    let bcArrLen = this.objBreadCrumbs.length - 1;
    let bThisFolder = (this.objBreadCrumbs[bcArrLen].id === folderid);
    while (!bThisFolder && bcArrLen >= 0) {
      this.objBreadCrumbs.pop();
      bcArrLen = this.objBreadCrumbs.length - 1;
      bThisFolder = (this.objBreadCrumbs[bcArrLen].id === folderid);
    }
    this.objCurrentFolder = this.objBreadCrumbsPath[folderid];
    return this.objBreadCrumbs;
  }

  createFolder(folderName) {
    let newFolder = this.storeWrap.createFolder(this.objCurrentFolder, folderName, []);
    this.storeWrap.pushData(this.objRootFolder, newFolder, this.objCurrentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, this.storeCreatedFolderToDB);
    //this.gotoFolder(this.objCreatedFolder);
    this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
  }

  createFolderStructure(folderName, template) {
    let newFolder = this.storeWrap.createFolder(this.objCurrentFolder, folderName, []);
    newFolder['template'] = [];
    return newFolder;
    // newFolder['template'].push({'id':template['id'],'filterParams':template.filterParams});
  }

  createRuleNameFolder(folderName, template, currentFolder, folderid = null, callback) {
    let newFolder = this.storeWrap.createFolder(currentFolder, folderName, []);
    newFolder.template = [];
    newFolder.template.push(template);
    if (folderid) {
      newFolder.folder_id = folderid;
      this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeDeleteFolder, this.deleteFolderToLocalMove, (_respFolder) => {
        this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, ((folder) => {
          callback(newFolder)
        }));
      })

    } else {
      this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, (respData => {
        // this.storeWrap.pushData(this.objCurrentParentFolder, newFolder, this.objCurrentParentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal,(respData=>{
        callback(newFolder)
      }));
    }

    //this.gotoFolder(this.objCreatedFolder);
    // this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
  }

  createFolderRuleRun(folderName, tagValue, currentFolder, parentFolder, folderId, callback) {
    if (currentFolder == null) {
      currentFolder = this.objCurrentParentFolder;
    }
    let newFolder: any = this.storeWrap.createFolder(currentFolder, folderName, []);
    newFolder = this.getFolderTemplateTag(parentFolder, newFolder, tagValue);

    // newFolder["template"]= template;
    // if(folderId)

    if (currentFolder.folders.find(folder => folder.folder_id == folderId)) {
      currentFolder.folders.find(folder => folder.folder_id == folderId)["files"] = [];
      newFolder.folder_id = folderId;
      this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeDeleteFolder, this.deleteFolderToLocalMove, (_respFolder) => {
        this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, ((folder) => {
          if (currentFolder.folders.findIndex(folder => folder.folder_id == folderId) == -1) {
            currentFolder.folders.push(newFolder)
          }
          callback(newFolder)
        }));
      })

    } else {
      this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, ((folder) => {
        // this.assignTemplateToFolder(template, this.objCreatedFolder, callback);
        // console.log(folder);
        callback(newFolder)
      }));
    }



    // let newFolder = this.storeWrap.createFolder(currentFolder, folderName, []);
    //   newFolder["template"]= template;
    // if(folderId){
    //   newFolder["folder_id"] = folderId;

    //   this.assignTemplateToFolder(template, newFolder, ((folder)=>{
    //     callback( newFolder)
    //   }));
    // }else{
    //   this.storeWrap.pushData(this.objRootFolder, newFolder, currentFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, ((folder)=>{

    //     callback( newFolder)
    //   }));
    // }

    // if(currentFolder==null){
    //   currentFolder = this.objCurrentParentFolder
    // }



    //this.gotoFolder(this.objCreatedFolder);
    // this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
  }
  getFolderTemplateTag(parentFolder, folder, tagValue) {
    var formLayoutArr = [];
    let folderTemplate: any;
    let filterParams = {};
    folderTemplate = { "Tag": { 'condition1': { "filterType": "text", "type": "equals", "filter": tagValue, 'operator': 'AND' } } };
    folder['template'] = [];
    let templateFields: any;
    let arrTemplate = this.storeWrap.storeTemplates[parentFolder.template[0].id];
    formLayoutArr.push(arrTemplate.formLayout);
    this.getFormFieldsData(formLayoutArr, (templateField) => {
      templateFields = templateField;
      let templateFieldsIdx = Object.keys(templateFields).findIndex(element => 'tag' === element.toLowerCase());
      if (templateFieldsIdx != -1) {
        let tagField = Object.keys(templateFields)[templateFieldsIdx];
        folderTemplate = { [tagField]: { 'condition1': { "filterType": "text", "type": "equals", "filter": tagValue, 'operator': 'AND' } } };
      }
    })
    if (parentFolder.template.length > 1) {
      parentFolder.template.forEach(element => {
        if (element.id == parentFolder.template[0].id) {
          folder['template'].push({ id: this.storeWrap.storeTemplates[element.id].id, 'filterParams': folderTemplate });
        } else {
          folder['template'].push({ id: this.storeWrap.storeTemplates[element.id].id, 'filterParams': {} });
        }

      });
    } else if (parentFolder.template.length == 1) {
      folder['template'].push({ id: this.storeWrap.storeTemplates[parentFolder.template[0].id].id, 'filterParams': folderTemplate });
    }
    return folder;
  }
  getAssignedTemplate = ((template) => {
  });
  ruleRunRenameFolder(foldername, currentFolder, callback) {
    let data = {
      'foldername': foldername,
      "currentfolder": currentFolder
    }

    ////
    currentFolder = this.reloadFolderTemplate(currentFolder);
    this.storeWrap.pushData(this.objRootFolder, data, this.objCurrentFolder, this.storeWrap.typeOfData.typeRenameFolder, this.ruleRunFolderUpdate, (folderUpdate) => {

    });
  }

  ruleRunFolderUpdate = ((folder) => {

  })
  storeCreatedFolderToDBRun = ((folder) => {
    //this.objCreatedFolder = folder;
    const toast = this.toastController.create({
      message: 'Folder Created Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  })

  shareFolder(folderCopied, destinationFolder, deleteSource = false, calback) {
    let copyFolder;
    // if(!deleteSource) {
    /*
    let newFolder = this.storeWrap.createFolder(this.objCurrentFolder, folderCopied.name, []);
    copyFolder = Object.assign({},newFolder, folderCopied);
    copyFolder.folder_id = newFolder.folder_id;
    copyFolder.parent_folder_id = destinationFolder.folder_id;
    copyFolder.path = [...destinationFolder.path];
    copyFolder.path.push(copyFolder.parent_folder_id);
    */
    //  copyFolder = this.storeWrap.copyFolder(this.getFolderStructure(), folderCopied)
    //  copyFolder.parent_folder_id = destinationFolder.folder_id;
    //  copyFolder.path = [...destinationFolder.path];
    //  copyFolder.path.push(copyFolder.parent_folder_id);
    //  destinationFolder.folders.push(copyFolder);
    // }
    // this.storeWrap.pushData(this.objRootFolder,copyFolder,folderCopied,this.storeWrap.typeOfData.typeFolder,this.storeCreatedFolderToLocal, this.storeCreatedFolderToDB);
    // this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
    //@santhiya to handle both copy/cut
    let newFolder = this.storeWrap.createFolder(this.objRootFolder, folderCopied.name, []);
    copyFolder = Object.assign({}, newFolder, folderCopied);
    copyFolder.folder_id = folderCopied.folder_id;
    copyFolder.parent_folder_id = destinationFolder.folder_id;
    copyFolder.path = [...destinationFolder.path];
    copyFolder.path.push(copyFolder.parent_folder_id);
    if (!deleteSource) {
      // this.objRootFolder, data, this.objCurrentFolder, 
      this.storeWrap.pushData(this.objRootFolder, copyFolder, this.objRootFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, calback);
    } else {
      this.storeWrap.pushData(this.objRootFolder, folderCopied, this.objCurrentFolder, this.storeWrap.typeOfData.typeDeleteFolder, this.deleteFolderToLocalMove, this.deleteFolderToDBMove);
      this.storeWrap.pushData(this.objRootFolder, copyFolder, this.objRootFolder, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, calback);
    }
    this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
  }
  storeSharedFolder = ((folder) => {
    console.log('posted Successfully');
  })
  moveFolder(folderCopied, destinationFolder, deleteSource = false, sourceFolder = null) {
    let copyFolder;
    let newFolder = this.storeWrap.createFolder(this.objCurrentFolder, folderCopied.name, []);
    copyFolder = Object.assign({}, newFolder, folderCopied);
    copyFolder.folder_id = newFolder.folder_id;
    copyFolder.parent_folder_id = destinationFolder.folder_id;
    copyFolder.path = [...destinationFolder.path];
    copyFolder.path.push(copyFolder.parent_folder_id);
    if (sourceFolder == null) {
      copyFolder.name = copyFolder.name.concat("-copy");
    }
    let tempFolder = this.storeWrap.getFolderStructure();
    delete tempFolder['template'];
    delete tempFolder['files'];
    delete tempFolder['folders'];
    var descFolder = this.mapFolderParams(tempFolder, copyFolder);
    var srcFolder = this.mapFolderParams(tempFolder, folderCopied);
    if (!deleteSource) {
      this.storeWrap.pushData(this.objRootFolder, descFolder, srcFolder, this.storeWrap.typeOfData.typeCopyFolder, this.storePasteFolderToLocal, (respData) => {
        if (this.objCurrentFolder.folders.length > 0) {
          this.objCurrentFolder.folders[this.objCurrentFolder.folders.length - 1] = copyFolder;
        } else {
          this.objCurrentFolder.folders[0] = copyFolder;
        }
        const toast = this.toastController.create({
          message: 'Folder Pasted Successfully.',
          duration: this.configApiService.toastDuration
        });
        toast.present();
      });
      // this.storeWrap.pushData(this.objRootFolder, copyFolder, folderCopied, this.storeWrap.typeOfData.typeFolder, this.storeCreatedFolderToLocal, this.storeCreatedFolderToDB);
    } else {
      this.storeWrap.pushData(this.objRootFolder, descFolder, srcFolder, this.storeWrap.typeOfData.typeMoveFolder, this.storePasteFolderToLocal, (respData) => {
        if (this.objCurrentFolder.folders.length > 0) {
          this.objCurrentFolder.folders[this.objCurrentFolder.folders.length - 1] = copyFolder;
        } else {
          this.objCurrentFolder.folders[0] = copyFolder;
        }
        const toast = this.toastController.create({
          message: 'Folder Pasted Successfully.',
          duration: this.configApiService.toastDuration
        });
        toast.present();
      });
      this.storeWrap.pushData(this.objRootFolder, folderCopied, sourceFolder, this.storeWrap.typeOfData.typeDeleteFolder, this.deleteFolderToLocalMove, this.deleteFolderToDBMove);
    }
    this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
  }

  mapFolderParams(tempFolder, objFolder) {
    var objTempFolder = {};
    Object.keys(tempFolder).forEach((paramValue) => {
      objTempFolder[paramValue] = objFolder[paramValue];
    });
    return objTempFolder;
  }

  storePasteFolderToLocal = ((folder) => {
    this.objCreatedFolder = folder;

  })

  storePasteFolderToDB = ((folder) => {
    //this.objCreatedFolder = folder;
    const toast = this.toastController.create({
      message: 'Folder Pasted Successfully db.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  })
  deleteFolderToLocalMove = ((result) => {

  })
  deleteFolderToDBMove = ((result) => {

  })
  storeCreatedFolderToLocal = ((folder) => {
    this.objCreatedFolder = folder;
  })

  storeCreatedFolderToDB = ((folder) => {
    //this.objCreatedFolder = folder;
    const toast = this.toastController.create({
      message: 'Folder Created Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  })

  createShareFolder(folder, shareType) {
    this.storeWrap.pushData(0, shareType, folder, this.storeWrap.typeOfData.typeSharedFolder, this.storeCreatedShareFolderToLocal, null);
    // this.gotoFolder(this.objCreatedFolder);
    // this.objCurrentFolder = this.objBreadCrumbsPath[this.objCurrentFolder.folder_id];
  }

  storeCreatedShareFolderToLocal = ((folder) => {
    this.objCreatedShareFolder = folder;
  })

  storeCreatedShareFolderToDB = ((folder) => {
    //this.objCreatedFolder = folder;
    // const toast = this.toastController.create({
    //       message: 'Folder Created Successfully.',
    //       duration: this.configApiService.toastDuration
    //   });
    // toast.present();     
  })

  showSharedFolder(data, cbck) {
    this.storeWrap.pullData(0, data, this.objCurrentFolder, this.storeWrap.typeOfApi.customSummary, this.storeWrap.typeOfData.typeSharedFolder, cbck)
  }

  reloadFolderTemplate(currentFolder) {
    let curFolderTemplateArr = []
    currentFolder.template.forEach((template) => {
      let templateID = template.id === 0 ? template.templateName : template.id;
      if (this.storeWrap.storeTemplates[templateID]) {
        curFolderTemplateArr.push(this.storeWrap.storeTemplates[templateID]);
      }
    })
    currentFolder['template'] = curFolderTemplateArr;

    return currentFolder;
  }

  renameFolder(currentFolder, templateProp, foldername) {
    let data = {
      'foldername': foldername,
      "currentfolder": currentFolder
    }

    ////
    currentFolder = this.reloadFolderTemplate(currentFolder);
    currentFolder.template.forEach((element, idx) => {
      let templateProps = { 'id': element.id, 'filterParams': templateProp[idx].filterParams }
      currentFolder.template[idx] = templateProps;
    });
    console.log('renamecurrentFolder', currentFolder);
    this.storeWrap.pushData(this.objRootFolder, data, this.objCurrentFolder, this.storeWrap.typeOfData.typeRenameFolder, this.renameFolderToLocal, this.renameFolderToDB);
  }

  renameSharedFolder(currentFolder, foldername) {
    let data = {
      'foldername': foldername,
      "currentfolder": currentFolder
    }
    this.storeWrap.pushData(this.objRootFolder, data, this.objCurrentFolder, this.storeWrap.typeOfData.typeRenameSharedFolder, this.renameFolderToLocal, this.renameFolderToDB);
  }

  renameFolderToLocal = ((resFolder) => {
    this.objCurrentFolder = resFolder;
    const toast = this.toastController.create({
      message: 'Folder Renamed Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  });

  renameFolderToDB = ((resFolder) => {
    const toast = this.toastController.create({
      message: 'Folder Renamed to DB Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  });
  shareInfoFolder(currentFolder, sharedInfo, callback) {
    delete sharedInfo.sharedFolder;
    this.storeWrap.pushData(this.objRootFolder, currentFolder, sharedInfo, this.storeWrap.typeOfData.typeShareInfoFolder, this.shareInfoFolderToLocal, (respData) => {

      callback(respData["_POST_PushFolderResult"][0].Ref_ID);
    });
  }
  shareInfoFolderToLocal = ((resFolder) => {
    const toast = this.toastController.create({
      message: 'Folder updated Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  });

  deleteFolder(currentFolder) {
    this.storeWrap.pushData(this.objRootFolder, currentFolder, this.objCurrentFolder, this.storeWrap.typeOfData.typeDeleteFolder, this.deleteFolderToLocal, this.deleteFolderToDB);
  }

  deleteSharedFolder(currentFolder) {
    this.storeWrap.pushData(this.objRootFolder, currentFolder, this.objCurrentFolder, this.storeWrap.typeOfData.typeDeleteSharedFolder, this.deleteFolderToLocal, this.deleteFolderToDB);
  }

  deleteFolderToLocal = ((resFolder) => {
    this.objCurrentFolder = resFolder;
    const toast = this.toastController.create({
      message: 'Folder deleted Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  });

  deleteFolderToDB = ((resFolder) => {
    const toast = this.toastController.create({
      message: 'Folder deleted to DB Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  });

  manageFilter(filterParams) {
    this.storeWrap.pullData(0, null, this.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.storeCurrentFileToLocal);
  }

  showContentSmartFolder(folder_ID, fParam) {
    this.storeWrap.pullData(0, null, this.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.storeCurrentFileToLocal);
  }

  createSmartFolder(folderName, filterParams, currentFolder = null, cbck = null) {
    if (currentFolder == null) {
      currentFolder = this.objCurrentFolder;
    }
    let data = {
      'fileName': folderName,
      'filterParams': filterParams
    }
    if (cbck == null) {
      if (this.pageName == 'drive') {
        this.storeWrap.pushData(this.objRootFolder, data, currentFolder, this.storeWrap.typeOfData.typeSmartFolder, this.storeSmartFolderToLocal, this.storeSmartFolderToDB);
      } else if (this.pageName == 'share') {
        this.storeWrap.pushData(this.objRootFolder, data, currentFolder, this.storeWrap.typeOfData.typeSharedSmartFolder, this.storeSmartFolderToLocal, this.storeSmartFolderToDB);
      }
    } else {
      if (this.pageName == 'drive') {
        this.storeWrap.pushData(this.objRootFolder, data, currentFolder, this.storeWrap.typeOfData.typeSmartFolder, this.storeSmartFolderToLocal, ((smfolder) => {
          cbck(this.objCreatedSmartFolder);
        }));
      } else if (this.pageName == 'share') {
        this.storeWrap.pushData(this.objRootFolder, data, currentFolder, this.storeWrap.typeOfData.typeSharedSmartFolder, this.storeSmartFolderToLocal, cbck);
      }
    }

  }


  storeSmartFolderToLocal = ((smfolder) => {
    this.objCreatedSmartFolder = smfolder;
  });

  storeSmartFolderToDB = ((smfolder) => {
    this.objCreatedSmartFolder = smfolder;
  });


  getTemplateIndex(templateIndex) {
    return templateIndex;
  }

  getFileNameParam() {
    return this.objFilterParams;
  }

  getTemplates = ((cbck) => {
    this.storeWrap.pullData(0, null, this.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeTemplate, (templateData) => {
      if (cbck) {
        this.templateManager.pushTemplates(templateData);
        cbck(templateData);
      }
    });
  })

  assignTemplateToFolder(templateconfig, currentFolder, cbck) {
    this.templateconfig = templateconfig;
    this.updateFolder = currentFolder;
    let Folder: any;
    if (currentFolder) {
      Folder = currentFolder;
    } else {
      Folder = this.objCurrentFolder;
    }
    this.storeWrap.pushData(this.objRootFolder, templateconfig, Folder, this.storeWrap.typeOfData.typeAssignTemplate, cbck, this.storeAssignTemplateToDB);

  }

  storeAssignTemplateToDB = ((template) => {
    if (template['_POST_PushFolderResult'][OBJLEN]['Result']) {
      let folderProp = this.objCurrentFolder.folders.find(folder => folder.folder_id == this.updateFolder.folder_id);
      folderProp.template = [];
      folderProp.template = this.templateconfig
      const toast = this.toastController.create({
        message: 'Template Assigned to DB Successfully.',
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  })


  gotoFile(templateIndex) {
    // this.objCurrentFile = this.objCurrentFolder['files'].findIndex(x=> x.RecordID ==value );
    // this.getCurrentFile();
    // this.objCurrentFolder['template'].findIndex(x=> x.fileName ==value );
  }

  createFile(fileObj) {
    this.storeWrap.pushData(0, fileObj, this.objCurrentFolder, this.storeWrap.typeOfData.typeFile, this.storeCurrentFileToLocal, this.storeCurrentFileToDB);
  }

  getBreadCrumbs() {
    return this.objBreadCrumbs;
  }

  getCurrentFolder() {
    return this.objCurrentFolder;
  }

  getMoveSourceFolder() {
    const objMoveFolder = { ...this.objCurrentFolder };
    this.objMoveSourceFolder = objMoveFolder;
    return this.objMoveSourceFolder;
  }

  getSingleTemplateColHeader() {
    return this.objCurrentFolder["template"][0]["colprops"];
  }

  getCurrentParentFolder(findex) {
    if (this.objRootFolder["folders"]) {
      if (this.objCurrentFolder['folders'][findex]['path'].length == 1) {
        this.objCurrentParentFolder = this.objCurrentFolder['folders'][findex];
        return this.objCurrentParentFolder;
      } else {
        return this.objCurrentParentFolder;
      }
    }
  }

  getCurrentFile() {
    return this.objCurrentFile;
  }

  getProgressBarTheme(statusId) {
    let data = {};
    data = {
      "id": statusId || 0,
      "bgColor": "limegreen",
      "iconColor": "white",
      "hrColor": "limegreen",
      "textColor": "black"
    }
    this.objStatusid.push(data);
    return this.objStatusid;
  }

  /**********
 * templateIndex - folderID
 * objCurrentFolder - current folder
 * Params - this params for samrt folder filter params used only for smart folder
 * type - typeof the data to be fecth
 * calback - calback 
 ******/

  pullSyncData(templateID, ffdata, currentFolder = null, api, type, cbck) {
    if (currentFolder != null) {
      this.objCurrentFolder = currentFolder;
    }

    if (!templateID && this.objCurrentFolder.template.length) {
      templateID = this.objCurrentFolder.template[0].id;
    }

    if (templateID) {
      if (type === this.storeWrap.typeOfData.typeFile) {
        // this.storeWrap.pullData(templateID, ffdata, this.objCurrentFolder, api, this.storeWrap.typeOfData.typeFilterParams, this.getFilterParams);
        this.storeWrap.pullData(templateID, ffdata, this.objCurrentFolder, api, this.storeWrap.typeOfData.typeFile, cbck);
      }

      else if (type === this.storeWrap.typeOfData.typeCustomApi) {
        this.storeWrap.pullData(templateID, ffdata, this.objCurrentFolder, api, type, cbck);
      }

      else if (type === this.storeWrap.typeOfData.typeSharedFile) {
        this.storeWrap.pullData(templateID, ffdata, this.objCurrentFolder, api, type, this.getSharedFileData);
        this.storeWrap.pullData(templateID, ffdata, this.objCurrentFolder, api, this.storeWrap.typeOfData.typeFilterParams, this.getFilterParams);
        // this.storeWrap.pullData(templateIndex,ffdata, this.objCurrentFolder, api, type, cbck);
      }
    }


  }

  // getFolderFiles = ((files) => {   
  //   this.CurrentFilesData = [];
  //   this.CurrentFilesData = files;     
  //   console.log('this.CurrentFilesData',this.CurrentFilesData)        
  // });

  getFilterParams = ((prams) => {
    this.objFilterParams = [];
    this.objFilterParams.push(prams);
    console.log('this.objFilterParams', this.objFilterParams)
  });

  getSharedFileData = ((data) => {
    // this.CurrentFilesData = [];
    this.objCurrentFolder.files.push(data.files);
    this.objCurrentFolder.template.push(data.template);
    this.CurrentFilesData.push(data['files']);
  })

  storeCurrentFileToLocal = ((file) => {
    this.CurrentFilesData = [];
    this.CurrentFilesData = file;
    this.objCurrentFolder["files"] = file;
  });

  storeCurrentFileToDB = ((file) => {
    this.CurrentFilesData = [];
    this.CurrentFilesData = file;
    this.objCurrentFolder["files"] = file;
  });

  /**********
 * templateIndex - folderID
 * objCurrentFolder - current folder
 * Params - this params for samrt folder filter params used only for smart folder
 * type - typeof the data to be fecth
 * calback - calback 
 *********/
  pushSyncData(templateIndex, ffdata, currentFolder = null, type, synccallback) {
    if (templateIndex === null) {
      templateIndex = 0;
    }
    if (currentFolder != null) {
      this.objCurrentFolder = currentFolder;
    }
    if (type === this.storeWrap.typeOfData.typeFile || type === this.storeWrap.typeOfData.typeCustomApi || type === this.storeWrap.typeOfData.typePostCustomApi) {
      this.storeWrap.pushData(templateIndex, ffdata, this.objCurrentFolder, this.storeWrap.typeOfData.typeFile, this.storeCurrentFileToLocal, synccallback);
      // clear filter params
      if (this.storeWrap.storeTemplates[templateIndex].reloadScreens) {
        this.storeWrap.storeTemplates[templateIndex].reloadScreens.forEach((reloadTemplateID) => {
          if (this.storeWrap.storeTemplates[reloadTemplateID] != undefined) {
            this.storeWrap.storeTemplates[reloadTemplateID]['fieldProperties'] = 0;
          }
        });

      }

    }
    else if (type === this.storeWrap.typeOfData.typePostTemplateHistoryApi) {
      this.storeWrap.pushData(templateIndex, ffdata, this.objCurrentFolder, type, null, synccallback);
    }
  }

  deleteData(templateID, ffdata, currentFolder = null, type, synccallback) {
    if (templateID === null) {
      return;
    }
    if (currentFolder != null) {
      this.objCurrentFolder = currentFolder;
    }
    // if(this.storeWrap.storeTemplates[templateID]['actionKey'] == ''){
    //   this.storeWrap.storeTemplates[templateID]['actionKey'] ='status'
    // }
    if (!this.storeWrap.storeTemplates[templateID]['actionKey'] || !this.storeWrap.storeTemplates[templateID]['sourceKey']) {
      console.log('no action key or source key available');
      return;
    }

    let pushParams = this.storeWrap.storeTemplates[templateID]['pushParams']
    if (ffdata.hasOwnProperty('PushArray')) {
      let pushParamData = [];
      ffdata['PushArray'].forEach((element, index) => {
        pushParams = Object.assign({}, pushParams, element);
        pushParams[this.storeWrap.storeTemplates[templateID]['actionKey']] = 'delete';
        pushParams[this.storeWrap.storeTemplates[templateID]['sourceKey']] = element[this.storeWrap.storeTemplates[templateID]['sourceKey']];
        delete pushParams['client'];
        delete pushParams['userid'];
        delete pushParams['RowNumber'];
        pushParamData.push(pushParams);
      });
      // let selectedRowData = [];
      //   for (const key in pushParamData) {
      //     const element = pushParamData[key];
      //     for (const [key, value] of Object.entries(element)) {
      //       if (key == "upload_id" || key == "status" || key == "rptname") {
      //       } else {
      //         delete element[key]
      //       }
      //     }
      //     selectedRowData.push(element);
      //   }

      // ffdata['PushArray'] = selectedRowData;
      ffdata['PushArray'] = pushParamData;
      this.storeWrap.pushData(templateID, ffdata, this.objCurrentFolder, this.storeWrap.typeOfData.typeFile, this.storeCurrentFileToLocal, synccallback);

    } else {
      pushParams[this.storeWrap.storeTemplates[templateID]['actionKey']] = 'delete';
      pushParams[this.storeWrap.storeTemplates[templateID]['sourceKey']] = ffdata[this.storeWrap.storeTemplates[templateID]['sourceKey']];
      this.storeWrap.pushData(templateID, pushParams, this.objCurrentFolder, this.storeWrap.typeOfData.typeFile, this.storeCurrentFileToLocal, synccallback);

    }
    // pushParams[this.storeWrap.storeTemplates[templateID]['actionKey']] = 'delete';
    // pushParams[this.storeWrap.storeTemplates[templateID]['sourceKey']] = ffdata[this.storeWrap.storeTemplates[templateID]['sourceKey']];

    /*
    if(type === this.storeWrap.typeOfData.typeFile || type === this.storeWrap.typeOfData.typeCustomApi || type === this.storeWrap.typeOfData.typePostCustomApi){
      this.storeWrap.pushData(templateIndex,ffdata,this.objCurrentFolder,this.storeWrap.typeOfData.typeFile,this.storeCurrentFileToLocal, synccallback);
      
    }
    else if(type === this.storeWrap.typeOfData.typePostTemplateHistoryApi){
      this.storeWrap.pushData(templateIndex,ffdata,this.objCurrentFolder,type,null, synccallback);
    }
    */
  }


  formatpostdata(json): string {
    let obj = { data: JSON.stringify(json) };
    let pdata = JSON.stringify(obj);
    return pdata;
  }

  loginUser(user: string, password: string): Promise<any> {
    const SUPER_ADMIN = 0
    const CLIENT_ADMIN = 1
    const Regular_USER = 2
    this.objUserLoginDetails['email_id'] = user;
    this.objUserLoginDetails['password'] = password;
    let data = {
      client: "eprodcast",
      rptname: 'EPC_APP_USERS',
      email_id: user,
      password: String(password),
      device_id: this.configureService.getDeviceId(),
      code: 'drive1.0',
      userid: "8",
      app_user_id: ""
    }
    let headers = this.configApiService.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      var url = this.configureService.getHost() + 'postadd/';
      return this.http.post(url, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {
          let response_data = data['_POST_AddMethodResult'][0];
          let getUserMessage = eval('(' + response_data['Message'] + ')');
          let getAppUserId = response_data['Ref_ID']
          this.objUserLoginDetails['message'] = getUserMessage;
          this.objUserLoginDetails['ref_Id'] = getAppUserId.split('=')[1];
          this.configureService.setLoginData(user, password);
          this.configureService.setLoginUserID(this.objUserLoginDetails['ref_Id']);
          this.configureService.setStudio(getUserMessage.studio);
          let accessCategory = getUserMessage["usertype"];
          this.adminAccess = accessCategory == SUPER_ADMIN ? true : false;
          this.adminUserid = this.adminAccess ? this.objUserLoginDetails.email_id : '';
          this.clientAdminAccess = accessCategory == CLIENT_ADMIN ? true : false;
          this.clientAdminId = this.clientAdminAccess ? this.objUserLoginDetails.email_id : '';
          this.userAccess = accessCategory == Regular_USER ? true : false;
          this.userId = this.userAccess ? this.objUserLoginDetails.email_id : '';
          if (this.adminAccess == true) {
            this.adminUserid = this.objUserLoginDetails.email_id
          }
          resolve(data);
        }, (err) => {
          console.log('error:Login:', err);
          reject(null);
        });
    });
  }

  duoAuthUser(user: string, password: string): Promise<any> {
    let data = {
      client: "eprodcast",
      rptname: 'EPC_APP_USERS',
      email_id: user,
    }
    let headers = this.configApiService.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      var url = 'http://localhost:8080/';
      return this.http.post(url, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {
          resolve(data);
        }, (err) => {
          console.log('error:Login:', err);
          reject(null);
        });
    });
  }

  resetPassword(email_id, old_password, new_password) {
    // var old_password = this.EncrDecrService.set('BETSYENC123$$', this.old_password);
    // var new_password = this.EncrDecrService.set('BETSYENC123$$', this.new_password);
    // var confirm_password = this.EncrDecrService.set('BETSYENC123$$', this.con_password);

    let data = {};
    // data = {
    //   "email": email_id,
    //   "Old_Password": old_password,
    //   "New_Password": new_password,
    //   "Confirm_Password": new_password,
    //   "userid": "3280",
    //   "rptname": "Reps581",
    //   "client": "Master74634"
    // }
    data = Object.assign({}, this.configApiService.driveApi.pushPassword.params, { "userid": this.configureService.getLoginUserID(), "email": email_id, "Old_Password": old_password, "New_Password": new_password, "Confirm_Password": new_password });
    let headers = this.configApiService.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      var url = this.configureService.getHost() + 'postadd/';
      return this.http.post(url, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {
          let response_data = data['_POST_AddMethodResult'][0];
          let getUserMessage = eval('(' + response_data['Message'] + ')');
          if (getUserMessage == "SUCCESS") {
            alert("Success");
          }
          resolve(data);
        }, (err) => {
          console.log('error:Login:', err);
          reject(null);
        });
    });
  }

  //************** Date Filter ****************//
  filterDate(filterLocalDateAtMidnight, cellValue) {
    var dateAsString = cellValue;
    if (dateAsString == null) return 0;
    var dateParts = dateAsString.split("-");
    var day = Number(dateParts[2]);
    var month = Number(dateParts[1]) - 1;
    var year = Number(dateParts[0]);
    var cellDate = new Date(day, month, year);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  //************** Date sorting ****************//
  dateComparator = ((date1, date2) => {
    var date1Number = this.monthToComparableNumber(date1);
    var date2Number = this.monthToComparableNumber(date2);
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  });

  monthToComparableNumber(date) {
    if (date === undefined || date === null || date.length !== 10) {
      return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
  }

  /* * * * * * * * * *
   * Clear Form Layout Data     
   * * * * * * * * */
  clearFormLayoutData(formLayout, params, isHeader) {
    let sourceKey;
    let paramKey = [];
    paramKey = Object.keys(params);
    if (paramKey.length) {
      sourceKey = Object.keys(params)[0];
    }
    let rowIdx = 0;
    let colIdx = 0;
    let fldIdx = 0;
    let defaultValue = 0;
    formLayout.forEach(cols => {
      cols.forEach(rows => {
        rows.fields.forEach(field => {
          if (field.FieldName != sourceKey) {
            if (field.FieldDataType == "DECIMAL") {
              formLayout[colIdx][rowIdx].fields[fldIdx].DefaultValue = defaultValue;
            } else {
              formLayout[colIdx][rowIdx].fields[fldIdx].DefaultValue = "";
            }
          }
          fldIdx = fldIdx + 1;
        });
        rowIdx = rowIdx + 1;
      });
      colIdx = colIdx + 1;
    });
    return formLayout;
  }


  ////////////////////////

  fetchScreenProperties(params, templateID, cbck) {
    // let ffdata:any = {};
    // let template = this.tabTemplates.find((template) => template.id == templateID);
    // if( template['sourceKey'] ) {
    //   ffdata[template['sourceKey']] = this.params[template['sourceKey']];
    // }

    // fetchinng source key from first / row clicked template
    let ffdata: any = {};
    let paramKey = [];
    paramKey = Object.keys(params);
    if (paramKey.length) {
      ffdata[paramKey[0]] = params[paramKey[0]];
    }
    /*    
        let sourceKey = this.storeWrap.storeTemplates[templateID]['sourceKey'];
        if(sourceKey) {
          ffdata[ sourceKey ] = params[sourceKey];
        } else { // remove this if not required
          console.log('***REMOVE CODE fetchScreenProperties**');
          let paramKey = [];
          paramKey = Object.keys(params);
          if(paramKey.length) {
            ffdata[ paramKey[0] ] = params[ paramKey[0] ];
          }
        }
        */
    let rowData: any;
    this.getFormFieldData(ffdata, templateID, (templateSettings, dataRows = null) => {
      if (dataRows != null) {
        rowData = dataRows[0]
      } else {
        rowData = ''
      }
      cbck(templateSettings, rowData);
    })
  }


  getFormGridData(paramData, templateID, cbck) {
    if (templateID) {
      this.pullSyncData(templateID, paramData, null, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeCustomApi, (currentFiles) => {
        cbck(currentFiles)
      })
    }
  }

  fetchTemplateProperties(paramData, fdata, templateID, cbck) {
    if (templateID) {
      this.pullSyncData(templateID, paramData, null, this.storeWrap.typeOfApi.fieldproperties, this.storeWrap.typeOfData.typeCustomApi, (fieldProperties) => {
        let templateSettings = this.storeWrap.storeTemplates[templateID];
        if (this.objCurrentParentFolder) {
          if (this.objCurrentParentFolder.IsReadOnlyShare) {
            templateSettings.fieldProperties.forEach(element => {
              element['IsReadOnly'] = this.objCurrentParentFolder.IsReadOnlyShare;
            });
          }
        }
        this.updateFormProperties(fdata, fieldProperties, templateSettings, cbck);
      })
    }
  }


  getFormFieldData(paramData, templateID, cbck) {
    /*
    let templateIdx = this.objCurrentFolder.template.findIndex( function(element, i){ return element.id === templateID} );
    if(templateIdx==-1){
      templateIdx =this.objCurrentFolder.template.findIndex( function(element, i){ return element.templateName === templateID} );
     }
     */
    if (templateID) {
      this.pullSyncData(templateID, paramData, null, this.storeWrap.typeOfApi.fieldproperties, this.storeWrap.typeOfData.typeCustomApi, (fieldProperties) => {
        // this.initForm(formFields, paramData, cbck);
        // templateIdx = this.storeWrap.storeTemplates.findIndex( function(element, i){ return element.templateName === templateName} );
        let templateSettings = this.storeWrap.storeTemplates[templateID];
        if (this.objCurrentParentFolder) {
          if (this.objCurrentParentFolder.IsReadOnlyShare) {
            templateSettings.fieldProperties.forEach(element => {
              element['IsReadOnly'] = this.objCurrentParentFolder.IsReadOnlyShare;
            });
          }
        }
        this.getRowData(templateID, paramData, templateSettings, cbck);
      })
    }
  }

  isFieldDataValid(fldProp, fldName, fldValue): any {
    let respData = {
      FieldName: '',
      message: fldValue + ' is invalid field. Please constcat system admin',
      IsValid: true,
      FieldValue: fldValue
    };
    if (!fldProp) {
      respData = {
        FieldName: '',
        message: fldValue + ' is invalid field. Please ask system admin',
        IsValid: false,
        FieldValue: fldValue
      };
    }
    else if (fldProp.IsRequired === 'YES' && fldValue === '') {
      respData = {
        FieldName: fldProp.FieldName,
        message: fldProp.DisplayName + ' is mandatory field. Please enter value and try again',
        IsValid: false,
        FieldValue: fldValue
      };
    }
    ////@santhiya commented above condition because decimal null value is getting failed
    else if (fldProp.FieldDataType === 'DECIMAL' && (fldValue === '' || fldValue === null || isNaN(fldValue))) {
      // else if (fldProp.FieldDataType === 'DECIMAL' && (!fldValue  || isNaN(fldValue))) { 
      respData = {
        FieldName: fldProp.FieldName,
        message: fldProp.DisplayName + ' is numeric field. Please enter value and try again',
        IsValid: false,
        FieldValue: fldValue
      };
    } else {
      respData = {
        FieldName: fldProp.FieldName,
        message: '',
        IsValid: true,
        FieldValue: fldValue
      };
    }

    return respData;
  }

  setFormDataToDb(templateID, formFields, formData, cbck) {
    let submitData = {};
    let fldProp = {};
    let bSaveData = true;
    let pushParams = {};
    let multiselectSubmitData = [];
    let multiSelectData = {};

    /*
    let templateIdx = this.objCurrentFolder.template.findIndex( function(element, i){ return element.id === templateID} );
    if(templateIdx==-1){
     templateIdx =this.objCurrentFolder.template.findIndex( function(element, i){ return element.id === templateID} );
    }

    pushParams = this.objCurrentFolder.template[templateIdx].pushParams;
    */

    pushParams = this.storeWrap.storeTemplates[templateID].pushParams;

    for (let element of Object.keys(pushParams)) {
      if (element === 'userid' || element === 'client' || element === 'rptname') {
        // system fields to be ignored
      } else {
        fldProp = formFields.find(({ FieldName }) => FieldName === element);
        if (fldProp['FieldDataType'] == "DATE") {
          if (formData[element]) {
            formData[element] = this.datePipe.transform(formData[element], 'yyyy-MM-dd');
          }
        } else if (fldProp['FieldDataType'] == "MULTISELECT_V") {
          if (formData[element]) {
            let _elementValue = formData[element].split(',');
            multiSelectData = Object.assign({}, multiSelectData, { [element]: _elementValue });
          }
        }
        let respData = this.isFieldDataValid(fldProp, element, formData[element])
        if (!respData.IsValid) {
          bSaveData = false;
          cbck(respData);
          break;
        } else {
          // submitData[element] = formData[element] ? formData[element] : this.objCurrentFolder.template[0].pushParams[element];

          // submitData[element] = respData.FieldValue;
          //@ss commented the above line because if the field value is undefined the field is not storing in the backend
          submitData[element] = respData.FieldValue == undefined ? "" : respData.FieldValue;
        }

      }
    }

    if (bSaveData) {
      /*
      if(this.objCurrentFolder.files.length <= templateIdx ) {
        this.objCurrentFolder.files.push([]);
      }
      */

      Object.keys(multiSelectData).forEach((data, index) => {
        console.log(multiSelectData[data])
        if (multiSelectData[data].length > 1) {
          multiSelectData[data].forEach(_data => {
            if (multiselectSubmitData.length > 0) {
              console.log(_data);
              submitData[this.storeWrap.storeTemplates[templateID].sourceKey] = 0;
            }
            multiselectSubmitData.push(Object.assign({}, submitData, { [data]: _data, "rptname": pushParams['rptname'] }));
          })
        }
      })
      if (multiselectSubmitData.length > 1) {
        submitData = { 'PushArray': multiselectSubmitData };
      }

      this.pushSyncData(templateID, submitData, this.objCurrentFolder, this.storeWrap.typeOfData.typePostCustomApi, (respData) => {
        if (respData.Result == "SUCCESS") {
          respData.IsValid = true;
          respData['message'] = 'Record Saved Successfully!';
        } else if (respData.Result == "FAIL" || respData.Result == "FAILED") {
          respData.IsValid = false;
          respData['message'] = respData.Message != '' || respData.Message != undefined ? respData.Message : 'Record Saved Failed!.Please try again..';
        }
        cbck(respData);
      });

    }
  }

  validateParams(arrParams, formFields): any {
    let isValidParam = true;
    Object.keys(arrParams).forEach(element => {
      if (!formFields.find(({ FieldName }) => FieldName === element)) {
        console.log('Params Field Mismatch', element)
        isValidParam = false;
      }
    });

    return isValidParam;

  }

  /*
  initForm(formFields, paramData, cbck) {  
    let formData = {};
    let formLookup = {};  
    this.validateParams(this.objCurrentFolder.template[0].pushParams, formFields);
    this.validateParams(this.objCurrentFolder.template[0].pullParams, formFields);      
    let __self = this;
   this.getRowData(paramData, formLookup, formData,formFields, cbck);
  }
  */
  // fetch row data from template
  getRowData(templateID, paramData, templateSettings, cbck) {
    this.checkcount = this.checkcount + 1;
    console.log(this.checkcount);
    // let data = Object.assign({}, this.paramData, { "userid": "3280", "rptname": "Basic_Profile597", "client": "HRSP74950"});
    if (paramData && Object.keys(paramData).length) {
      this.pullSyncData(templateID, paramData, null, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, (data) => {
        let fdata: any;
        if (data[0].length > 0) {
          fdata = Object.assign(data[0][0], paramData);
        } else {
          fdata = paramData;
        }
        // data[0][0][templateSettings.sourceKey] = paramData[templateSettings['sourceKey']];
        this.updateFormProperties(fdata, data, templateSettings, cbck);
      })
    } else { // Handling new row
      if (templateSettings.sourceKey) {
        paramData[templateSettings['sourceKey']] = 0;
      }
      let data = [];
      this.updateFormProperties(paramData, data, templateSettings, cbck);
    }

  }

  formatFormFieldProp(fieldProp, sysfldProp, rowDbData) {
    let pluginData: any = {};
    let customFieldDataType: any;
    let field = fieldProp
    if (rowDbData[fieldProp.FieldName] === undefined) {
      // if (field.FieldDataType == "TEXT") {
      //   field.DefaultValue = (sysfldProp === undefined ? fieldProp.DefaultValue : sysfldProp.DefaultValue);
      // } else {
      //   field.DefaultValue = (sysfldProp === undefined ? fieldProp.DefaultValue : sysfldProp.DefaultValue[0]);
      // }
      field.DefaultValue = fieldProp.DefaultValue != undefined ? fieldProp.DefaultValue : sysfldProp.DefaultValue[0];
      field.Form = (sysfldProp === undefined ? "1" : sysfldProp['Form']);
      field.ParentFld = (sysfldProp === undefined ? "NO" : sysfldProp['ParentFld']);
      field.PluginData = (sysfldProp === undefined ? "" : sysfldProp['PluginData']);
      field.FilterType = (sysfldProp === undefined ? "" : sysfldProp['FilterType']);
      field.SortIdx = (sysfldProp === undefined ? 0 : Number(sysfldProp['SortIdx']));
      field.IsReadOnly = (sysfldProp === undefined ? "" : sysfldProp['IsReadOnly']);
      field.IsRequired = (sysfldProp === undefined ? "NO" : sysfldProp['IsRequired']);
      field.Summary = (sysfldProp === undefined ? "" : sysfldProp['Summary']);
    } else {
      field.DefaultValue = rowDbData[fieldProp.FieldName];
      field.Form = (sysfldProp === undefined ? "1" : sysfldProp['Form']);
      field.ParentFld = (sysfldProp === undefined ? "NO" : sysfldProp['ParentFld']);
      field.PluginData = (sysfldProp === undefined ? "" : sysfldProp['PluginData']);
      field.FilterType = (sysfldProp === undefined ? "" : sysfldProp['FilterType']);
      field.SortIdx = (sysfldProp === undefined ? 0 : Number(sysfldProp['SortIdx']));
      field.IsReadOnly = (sysfldProp === undefined ? "" : sysfldProp['IsReadOnly']);
      field.IsRequired = (sysfldProp === undefined ? "NO" : sysfldProp['IsRequired']);
      field.Summary = (sysfldProp === undefined ? "" : sysfldProp['Summary']);
    }
    field.FieldName = fieldProp.FieldName;
    field.DisplayName = fieldProp.DisplayName;
    field.FieldDataType = fieldProp.FieldDataType;
    let objPluginData = sysfldProp.PluginData != "" ? JSON.parse(sysfldProp["PluginData"]) : "";


    if (sysfldProp) {
      let format
      if (sysfldProp.PluginData.trim().length) {
        try {
          format = JSON.parse(sysfldProp.PluginData);
        } catch (e) {
        }
        pluginData = format != undefined ? format : "{}";
        customFieldDataType = pluginData['customFieldDataType'];
      }
      if (customFieldDataType) {
        field['FieldDataType'] = customFieldDataType;
      }
    }

    if (fieldProp.FieldDataType === "SELECT" || fieldProp.FieldDataType === "MULTISELECT_V") {
      let fldidx = 0;

      if (fieldProp.FieldDataType === "DYNAMIC-LOOKUP") {
        if (sysfldProp && sysfldProp.FieldValues != "") {
          let fldidx = 0;
          let optionValArr = JSON.parse(sysfldProp.FieldValues);
          field['options'] = [];
          optionValArr.forEach(optionValue => {
            field['options'].push({ key: optionValue[Object.keys(optionValue)[0]], label: optionValue[Object.keys(optionValue)[1]] });
            fldidx = fldidx + 1;
          });
        }
      }
      else if (fieldProp.FieldDataType === "MULTISELECT_V") {
        let fldidx = 0;
        if (sysfldProp && sysfldProp.FieldValues != "") {
          let optionValArr = JSON.parse(sysfldProp.FieldValues);
          field['options'] = [];
          optionValArr.forEach(optionValue => {
            field['options'].push({ 'id': optionValue[Object.keys(optionValue)[0]], 'itemName': optionValue[Object.keys(optionValue)[1]] });
            fldidx = fldidx + 1;
          });
        }
      } else {
        let fldidx = 0;
        if (sysfldProp && sysfldProp.FieldValues != "") {
          let optionValArr = JSON.parse(sysfldProp.FieldValues);
          field['options'] = [];
          optionValArr.forEach(optionValue => {
            let lookupField = {};
            if (Object.keys(objPluginData).includes('parentCol')) {
              objPluginData['parentCol'].forEach(Column => {
                lookupField['key'] = optionValue[Object.keys(optionValue)[0]],
                  lookupField['label'] = optionValue[Object.keys(optionValue)[1]],
                  lookupField[Column] = optionValue[Column]
              });
              field['options'].push(lookupField);
              fldidx = fldidx + 1;
            } else {
              lookupField['key'] = optionValue[Object.keys(optionValue)[0]],
                lookupField['label'] = optionValue[Object.keys(optionValue)[1]]
              field['options'].push(lookupField)
              fldidx = fldidx + 1;
            }
          });
        }
      }
    } else if (fieldProp.FieldDataType === "DYNAMIC-LOOKUP") {
      if (sysfldProp && sysfldProp.FieldValues != "") {
        let fldidx = 0;
        let optionValArr = JSON.parse(sysfldProp.FieldValues);
        field['options'] = [];
        optionValArr.forEach(optionValue => {
          field['options'].push({ key: optionValue[Object.keys(optionValue)[0]], label: optionValue[Object.keys(optionValue)[1]] });
          fldidx = fldidx + 1;
        });
      }
    }

    if (Object.keys(objPluginData).includes('parentCol')) {
      field['optionValue'] = JSON.stringify(field['options']);
    }
    return field;
  }

  updateFormProperties(rowDbData, gridData = [], templateSettings, cbck) {
    templateSettings = this.clone(templateSettings);
    let filterParams = this.objCurrentFolder.template.filter(temp => temp.id == templateSettings.id)[OBJLEN] != undefined ? this.objCurrentFolder.template.filter(temp => temp.id == templateSettings.id)[OBJLEN]['filterParams'] : {};
    templateSettings['filterParams'] = Object.keys(filterParams)['length'] != OBJLEN ? filterParams : {};
    let formLayout = templateSettings['formLayout'];
    let rowIdx = 0;
    let colIdx = 0;
    formLayout.forEach((rowElem) => {
      // console.log(rowElem)
      rowElem.forEach((colElem) => {
        let arrFieldIdx = 0;
        colElem.fields.forEach((field) => {
          let idx = 1;
          let sysfldProp = templateSettings.fieldProperties.find(({ FieldName }) => FieldName === field.FieldName);
          if (this.gridNewForm) {
            if (Object.keys(templateSettings.filterParams).length != OBJLEN && Object.keys(templateSettings.filterParams).includes(field.FieldName)) {
              Object.keys(templateSettings.filterParams[field.FieldName]).forEach(elem => {
                if (elem == 'condition' + idx) {
                  sysfldProp.DefaultValue = templateSettings.filterParams[field.FieldName][elem]['filter'];
                  field.DefaultValue = templateSettings.filterParams[field.FieldName][elem]['filter'];
                  sysfldProp['IsReadOnly'] = 'YES';
                  idx + 1;
                }
              })
            }
          }
          field = this.formatFormFieldProp(field, sysfldProp, rowDbData);
          templateSettings['formLayout'][rowIdx][colIdx].fields[arrFieldIdx] = field;
          arrFieldIdx = arrFieldIdx + 1;
        });
        colIdx = colIdx + 1;
      })
      rowIdx = rowIdx + 1;
    });
    if (gridData.length > 0) {
      cbck(templateSettings, gridData);
    } else {
      cbck(templateSettings);
    }
  }

  ////////////
  fetchTemplateData(templateName, callback) {
    let data = Object.assign({}, this.configApiService.driveApi.pullTemplateData.params, { "module_id": templateName, "userid": this.configureService.getLoginUserID(), "client": this.configureService.getStudio() });
    this.configApiService.fieldpropertyRequest(data, (respData) => {
      callback(respData);
    });
  }

  fetchTemplateFields(templateName, callback) {
    // let data ={"client":"Studio88953","userid":3280,"start":1,"end":10,"rptname":"XAPP_FIELD_PROPERTIES41","module_id":templateName};
    //@santhiya config api service api is added
    let data = Object.assign({}, this.configApiService.driveApi.pullFieldData.params, { "module_id": templateName, "userid": this.configureService.getLoginUserID(), "client": this.configureService.getStudio() });
    this.configApiService.pullRequest(data, (respData) => {
      callback(respData);
    });
  }

  fetchTemplateFieldLookup(templateName, callback) {
    // let data ={"client":"Studio88953","userid":3280,"start":1,"end":10,"rptname":"XAPP_FIELD_PROPERTIES41","module_id":templateName};
    //@santhiya config api service api is added
    let data = Object.assign({}, this.configApiService.driveApi.pullFieldData.params, { "module_id": templateName, "userid": this.configureService.getLoginUserID(), "client": this.configureService.getStudio() });
    this.configApiService.pullRequest(data, (respData) => {
      callback(respData);
    });
  }

  saveTemplateField(templateName, fieldProp, callback) {
    // let objData = Object.assign({},fieldProp,{"client":"Studio88953","module_id":templateName,"userid":3280,"rptname":"XAPP_FIELD_PROPERTIES34"})
    //@santhiya config api service api is added
    let objData = Object.assign({}, this.configApiService.driveApi.pushFieldProperty.params, fieldProp, { "module_id": templateName, "userid": this.configureService.getLoginUserID(), "client": this.configureService.getStudio() });
    // this.pushFieldData(objData,callback)
    this.configApiService.pushRequest(objData, (respData) => {
      callback(respData);
    })
  }

  publishTemplate(templateName, callback) {
    // http://192.168.65.212:82/EPCSTUDIO.svc/EPC_PUBLISH_SCREEN/
    //@santhiya config api service api is added
    let postdata = Object.assign({}, this.configApiService.driveApi.publishTemplate.params, { "screen": templateName, "client": this.configureService.getStudio(), "app_code": this.configApiService.currentDriveApp['app_code'] });
    this.configApiService.customRequest(this.configApiService.publishScreenApi, postdata, (respData) => {
      this.getTemplates(() => {
        callback(respData);
      });

    })
  }

  postLookup(ffid, data, callback) {
    // let objData =  Object.assign({},data,{"field_properties_id":ffid,"client":"Studio88953","rptname":"Field_Lookup11","userid":"3994"})
    //@santhiya config api service api is added
    let objData = Object.assign({}, this.configApiService.driveApi.pushLookup.params, data, { "field_properties_id": ffid, "client": this.configureService.getStudio(), "userid": this.configureService.getLoginUserID() });
    this.configApiService.pushRequest(objData, (respData) => {
      callback(respData);
    })
  }
  /////////////New Template Creation ////////////
  postNewTemplate(data, callback) {
    //@santhiya config api service api is added
    let objData = Object.assign({}, this.configApiService.driveApi.pushNewTemplate.params, data);
    objData = Object.assign({}, objData, { "client": this.configureService.getStudio(), "userid": this.configureService.getLoginUserID(), "app_code": this.configApiService.currentDriveApp['app_code'] });
    this.configApiService.pushRequest(objData, (respData) => {
      callback(respData);
    })
  }
  /////////////////
  /////////////////


  ////////////
  pullConfigurationApi(ffdataref, ffdata, api, type, cbck) {
    if (type === this.configApiService.typeOfData.typeStudio) {
      this.configApiService.pullData(ffdataref, ffdata, api, this.configApiService.typeOfData.typeStudio, cbck);
    } else if (type === this.configApiService.typeOfData.typeLookup) {
      this.configApiService.pullData(ffdataref, ffdata, api, this.configApiService.typeOfData.typeLookup, cbck);
    } else if (type === this.configApiService.typeOfData.typeLoopList) {
      this.configApiService.pullData(ffdataref, ffdata, api, this.configApiService.typeOfData.typeLoopList, cbck);
    }
  }
  pushConfigurationApi(ffdata, type, cbck) {
    if (type === this.configApiService.typeOfData.typeStudio) {
      this.configApiService.pushData(ffdata, this.configApiService.typeOfData.typeStudio, cbck);
    } else if (type === this.configApiService.typeOfData.typeLookup) {
      this.configApiService.pushData(ffdata, this.configApiService.typeOfData.typeStudio, cbck);
    } else if (type === this.configApiService.typeOfData.typeField) {
      this.configApiService.pushData(ffdata, this.configApiService.typeOfData.typeField, cbck);
    }
  }

  //////////////////////////// Template Manager Get Field Type ////////////////////////////////////
  getFieldType(data, cbck) {
    this.configApiService.fieldpropertyRequest(data, (respData) => {
      cbck(respData);
    });
  }
  //////////////////////////////////////////////////

  pullContactData(templateID, ffdata, currentFolder = null, api, type, cbck) {
    if (!templateID && currentFolder.template.length) {
      templateID = currentFolder.template[0].id;
    }
    if (templateID) {
      if (type === this.storeWrap.typeOfData.typeFile) {
        this.storeWrap.pullData(templateID, ffdata, currentFolder, api, this.storeWrap.typeOfData.typeFilterParams, this.getFilterParams);
        this.storeWrap.pullData(templateID, ffdata, currentFolder, api, this.storeWrap.typeOfData.typeFile, cbck);
      }
    }


  }
  //////////////////////////// Get AppList Type ////////////////////////////////////
  /*
   getApplist(paramData, templateID, cbck) {
     if (templateID) {
       this.pullSyncData(templateID, paramData, null, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeCustomApi, (currentFiles) => {
         cbck(currentFiles)
       })
     }
   }
   */

  /* * * * * *
   * get push param @prabha
   * * * * * */
  getPushParamKeys(pushParam) {
    var item = {};
    Object.keys(pushParam).forEach(function (key) {
      if (key != 'userid' && key != 'client') {
        item[key] = pushParam[key];
      }
    });
    return item;
  }

  /* * * * * *
   * method for multiple templates push data handle @prabha
   * * * * * */
  mapFormtoPushData(formData, templates) {
    var obj = [];
    templates.forEach((template) => {
      var item = {};
      let pushParam = this.getPushParamKeys(template.pushParams);
      Object.keys(formData).forEach(function (dataKey) {
        Object.keys(pushParam).forEach(function (pushParamKey) {
          if (dataKey === pushParamKey) {
            item[pushParamKey] = formData[pushParamKey];
          }
        })
      })

      var _item = Object.assign({}, pushParam, item);
      for (var rowidx = 0; rowidx < template.formLayout.length; rowidx++) {
        for (var colidx = 0; colidx < template.formLayout[rowidx].length; colidx++) {
          template.formLayout[rowidx][colidx].fields.forEach(element => {
            if (element.FieldDataType == "DATE" && _item.hasOwnProperty(element.FieldName)) {
              if (_item[element.FieldName] != "") {
                _item[element.FieldName] = this.datePipe.transform(_item[element.FieldName], 'yyyy-MM-dd');
              }
            }
          });
        }
      }
      obj.push(_item);
    });
    return obj;
  }

  /* * * * * *
   * date formate
   * * * * * */
  formatDate(d) {
    var date;
    if (d != null) {
      date = new Date(d);
    } else {
      date = new Date();
    }
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    return date;
  };

  /* * * * * *
   * method for multiple templates set data @prabha
   * * * * * */
  setMutiTemplateFormData(formLayoutArr, cbck) {
    let fieldsCtrls = {};
    for (let formLayout of formLayoutArr) {
      for (let formFiled of formLayout) {
        for (let layout of formFiled) {
          let fields = layout['fields'];
          if (fields) {
            for (let f of fields) {
              if (this.objCurrentParentFolder) {
                if (this.objCurrentParentFolder.IsReadOnlyShare) {
                  if (f['IsReadOnly'] != "YES") {
                    f['IsReadOnly'] = this.objCurrentParentFolder.IsReadOnlyShare;
                  }
                }
              }
              var readOnly = !f.IsReadOnly || f.IsReadOnly == "NO" ? false : true;
              if (f.FieldDataType === 'checkbox') {
                let opts = {};
                for (let opt of f.options) {
                  opts[opt.key] = new FormControl({ value: opt.value, disabled: readOnly });
                }
                fieldsCtrls[f.FieldName] = new FormGroup(opts)
              }
              else if (f.FieldDataType === 'SELECT') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.label === f.DefaultValue) {
                      selectedOpt = opt.key;
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl({ value: selectedOpt ? selectedOpt : f.DefaultValue, disabled: readOnly }, Validators.required);
              }
              else if (f.FieldDataType === 'DYNAMIC-LOOKUP') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.label === f.DefaultValue) {
                      selectedOpt = opt.key;
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl({ value: selectedOpt ? selectedOpt : f.DefaultValue, disabled: readOnly }, Validators.required);
              }
              else if (f.FieldDataType === 'MULTISELECT_V') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.id === f.DefaultValue) {
                      selectedOpt = opt;
                    } else {
                      selectedOpt = f.options[0];
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl({ value: selectedOpt ? selectedOpt : [], disabled: readOnly }, Validators.required)
              }
              else if (f.FieldDataType === 'DATE') {
                let date;
                if (f.DefaultValue) {
                  date = this.datePipe.transform(this.formatDate(f.DefaultValue), 'yyyy-MM-dd');
                } else {
                  date = this.datePipe.transform(this.formatDate('1900-01-01'), 'yyyy-MM-dd');
                }

                fieldsCtrls[f.FieldName] = new FormControl({ value: date, disabled: readOnly }, Validators.required)
              }
              else {
                fieldsCtrls[f.FieldName] = new FormControl({ value: f.DefaultValue, disabled: readOnly }, Validators.required)
              }
            }

          }
        }
      }
    }
    console.log("fieldsCtrls", fieldsCtrls);
    this.myForm = new FormGroup(fieldsCtrls);
    cbck(this.myForm);
  }

  /* * * * * *
  * method for multiple templates set data
  * * * * * */
  setSingleTemplateFormData(formLayoutArr, cbck) {
    let fieldsCtrls = {};
    for (let rowIdx = 0; rowIdx < formLayoutArr.length; rowIdx++) {
      let formLayout = formLayoutArr[rowIdx];
      for (let colIdx = 0; colIdx < formLayout.length; colIdx++) {
        let formFiled = formLayout[colIdx];
        // for (let layout of formFiled) {
        let fields = formFiled['fields'];
        if (fields) {
          for (let f of fields) {
            if (this.objCurrentParentFolder) {
              if (this.objCurrentParentFolder.IsReadOnlyShare) {
                if (f['IsReadOnly'] != "YES") {
                  f['IsReadOnly'] = this.objCurrentParentFolder.IsReadOnlyShare;
                }
              }
            }
            var readOnly = !f.IsReadOnly || f.IsReadOnly == "NO" ? false : true;
            if (f.FieldDataType === 'checkbox') {
              let opts = {};
              for (let opt of f.options) {
                opts[opt.key] = new FormControl({ value: opt.value, disabled: readOnly });
              }
              fieldsCtrls[f.FieldName] = new FormGroup(opts)
            }
            else if (f.FieldDataType === 'SELECT') {
              let selectedOpt;
              if (f.options) {
                for (let opt of f.options) {
                  if (opt.label === f.DefaultValue) {
                    selectedOpt = opt.key;
                  }
                }
              }
              fieldsCtrls[f.FieldName] = new FormControl({ value: selectedOpt ? selectedOpt : f.DefaultValue, disabled: readOnly }, Validators.required);
            }
            else if (f.FieldDataType === 'DYNAMIC-LOOKUP') {
              let selectedOpt;
              if (f.options) {
                for (let opt of f.options) {
                  if (opt.label === f.DefaultValue) {
                    selectedOpt = opt.key;
                  }
                }
              }
              fieldsCtrls[f.FieldName] = new FormControl({ value: selectedOpt ? selectedOpt : f.DefaultValue, disabled: readOnly }, Validators.required);
            }
            else if (f.FieldDataType === 'MULTISELECT_V') {
              let selectedOpt;
              if (f.options) {
                for (let opt of f.options) {
                  if (opt.id === f.DefaultValue) {
                    selectedOpt = opt;
                  } else {
                    selectedOpt = f.options[0];
                  }
                }
              }
              fieldsCtrls[f.FieldName] = new FormControl({ value: selectedOpt ? selectedOpt : [], disabled: readOnly }, Validators.required)
            }
            else if (f.FieldDataType === 'DATE') {
              let date;
              if (f.DefaultValue) {
                date = this.datePipe.transform(this.formatDate(f.DefaultValue), 'yyyy-MM-dd');
              } else {
                date = this.datePipe.transform(this.formatDate('1900-01-01'), 'yyyy-MM-dd');
              }

              fieldsCtrls[f.FieldName] = new FormControl({ value: date, disabled: readOnly }, Validators.required)
            }
            else {
              fieldsCtrls[f.FieldName] = new FormControl({ value: f.DefaultValue, disabled: readOnly }, Validators.required)
            }
          }

        }
        // } 
      }
    }
    console.log("fieldsCtrls", fieldsCtrls);
    this.myForm = new FormGroup(fieldsCtrls);
    cbck(this.myForm);
  }
  /* * * * * *
  * get Form data
  * * * * * */
  getFormFieldsData(formLayoutArr, cbck) {
    let formFields = {};
    for (let formLayout of formLayoutArr) {
      for (let formFiled of formLayout) {
        for (let layout of formFiled) {
          let fields = layout['fields'];
          if (fields) {
            for (let f of fields) {
              formFields[f.FieldName] = f;
            }
          }
        }
      }
    }
    cbck(formFields);
  }

  /* * * * * *
  * Delete Template
  * * * * * */
  deleteTemplate(templateID) {
    this.storeWrap.deleteTemplate(templateID);
  }

  /* * * * * *
  * Method for lookup Data update in stored Template
  * * * * * */
  updateFieldPropertyLookup(templateID) {
    this.storeWrap.updateFieldFroperties(templateID);
  }

  /**************
   * Assign Dummy folder
   * ***************** */
  assignFolderStructure(fname, objtemplate, fdata = null) {
    let objFolder = this.storeWrap.createFolder(this.objRootFolder, fname, []);
    let arrTemplate: any = [];
    for (var i = 0; i < objtemplate.length; i++) {
      arrTemplate.push({ 'id': objtemplate[i].id, 'filterParams': objtemplate[i].filterParams });
    }
    objFolder.template = arrTemplate;
    if (fdata != null) {
      objFolder = Object.assign({}, objFolder, fdata);
    }
    return objFolder;
  }

  setShareUserData(_data) {
    this.objShareUserData = _data;
  }
  /********
   * Update Folder
   * ******** */
  updateFolderProperty(ffdata, currentFolder, cbck) {
    let Folder: any;
    if (currentFolder) {
      Folder = currentFolder;
    } else {
      Folder = this.objCurrentFolder;
    }
    if (!ffdata) {
      ffdata = currentFolder;
    }
    this.storeWrap.pushData(this.objRootFolder, ffdata, Folder, this.storeWrap.typeOfData.typeFolderProperty, cbck, this.storeFolderPropertyToDB);

  }

  storeFolderPropertyToDB = ((template) => {
    const toast = this.toastController.create({
      message: 'Folder Updated Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  })
  /*****
   * Dashboard Tracker
   * **** */
  getTrackerCurrentSettings(prop) {
    this.objCurrentTrackerProp = prop;
    return this.objCurrentTrackerProp;
  }

  setDeskData(objDesk) {
    this.objDeskData = objDesk;
  }

  getDummyFolder(folderId) {
    this.deskDummyFolderId = folderId;
  }

  setSelectedTracker(tracker, index) {
    this.selectedTracker = tracker;
    this.selectedTrackerIndex = index;
  }

  createInstance(): Rx.Subject<any> {
    const instance = new Rx.Subject<any>();

    return instance;
  }

  public getInstance(): Rx.Subject<any> {

    if (!this.instance) {
      this.instance = this.createInstance();
    }

    return this.instance;
  }

  LeftSideNavBar(style: string): void {
    this.setSideBar.next(style);
  }

  // program to generate random strings
  generateString(length) {
    const characters = 'ABCDEFGHIJ';
    let result = '';;
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  // MULTIPLE ROW DELETE
  deleteMultiRecords(objDeleteItems, templateID) {
    this.pushDeleteData = objDeleteItems;
    this.objTemplateID = templateID;
    this.startPushingData();
  }

  startPushingData() {
    const DELETE_ITEM_SCOUNT = 25;
    if (this.pushDeleteData.length > this.deleteDataIdx) {
      var obj = this.pushDeleteData.slice(this.deleteDataIdx, this.deleteDataIdx + DELETE_ITEM_SCOUNT);
      this.pushObjDelete(obj);
    } else {
      var obj = this.pushDeleteData.slice(this.deleteDataIdx, this.pushDeleteData.length);
      if (obj.length > 0) {
        this.pushObjDelete(obj);
      } else {
        const toast = this.toastController.create({
          message: 'Row is deleted successfully..',
          duration: this.configApiService.toastDuration
        });
        toast.present();
        const ObjIdx = 0;
        this.deleteDataIdx = ObjIdx;
      }
    }
  }

  pushObjDelete(formData) {
    let obj = {
      PushArray: formData
    };
    this.deleteData(this.objTemplateID, obj, null, this.storeWrap.typeOfData.typePostCustomApi, this.submitSucess);
  }
  sendSms(smsData) {
    let bodyHtml: any = '';
    bodyHtml += smsData
    return bodyHtml;
  }
  submitSucess = ((resData) => {
    const DELETE_ITEM_SCOUNT = 25;
    this.deleteDataIdx = this.deleteDataIdx + DELETE_ITEM_SCOUNT;
    this.startPushingData();
  });

  getShareUserList(objCurrentFolder, userId, callback) {
    let pullParams = {
      "UserFolder": objCurrentFolder['folder_id'],
      "userid": userId
    }
    let pullObjData = Object.assign({}, this.configApiService.driveApi.pullLinkShareUser.params, pullParams);
    this.configApiService.pullRequest(pullObjData, (respData) => {
      callback(respData);
    })
  }

  storeTodrive(pushFolderData, callback) {
    let pushParams = Object.assign({}, pushFolderData)
    let objData = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.storeWrap.licenceClientDB, pushParams)
    this.configApiService.customRequest(this.configApiService.pushFolder, objData, (respData) => {
      callback(respData);
    })
  }

  listUsersAssignedToEpc() {
    let PullParams = {
      "targetepc": this.configApiService.currentDriveApp['app_code'],
    }
    this.configApiService.customRequest(this.configApiService.fetchUserLicenceAccessApi, PullParams, (resp) => {
      let userDetails = JSON.parse(resp["_POST_EPC_FETCH_USER_LICENSE_ACCESSResult"])
      this.ObjCurrentAppUsers = userDetails;
    })
  }
  private customSubject = new Subject<any>();
  customObservable = this.customSubject.asObservable();
  callComponentMethod(value: any) {
    this.customSubject.next(value);
  }

  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }

  toEmptyFiles(folders) {
    folders.forEach(element => {
      Object.keys(element).forEach(key => {
        if (key == 'files') {
          element[key] = [];
        }
        if (key == 'folder') {
          element.forEach(folder => {
            Object.keys(folder).forEach(key => {
              if (key == 'files') {
                element[key] = [];
              }
            });
          });
        }
      });
    });
    return folders;
  }

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  pushWatchAccessApi(watchuserEmaillist, currentTemplateProps, objCurrentFolder, userId) {
    let objWashPushArray = [];
    let userID = userId;
    watchuserEmaillist.forEach(element => {
      let pushParams = {
        'accessID': element.accessId,
        'watchFlag': element.watchTag,
        'folderID': objCurrentFolder.folder_id,
        'templateID': currentTemplateProps['id'],
        'folderPath': JSON.stringify(objCurrentFolder.path),
        'folderProps': JSON.stringify(objCurrentFolder),
        'folderName': objCurrentFolder.name,
        "templateName": currentTemplateProps['templateName'],
        'email_id': element.email,
        'Reciever_user_id': element.userid,
        'app_code': this.configApiService.currentDriveApp['app_code'],
      }
      let objData = Object.assign({}, this.configApiService.driveApi.pushWatchTab.params, pushParams)
      delete objData['userid'];
      delete objData['client'];
      objWashPushArray.push(objData);
    });
    this.postWatchAccessApi(objWashPushArray, userID);

  }

  postWatchAccessApi(objWashPushArray, userID) {
    let obj = {
      PushArray: objWashPushArray
    };
    let pushParams = this.configApiService.driveApi.pushWatchTab.params;
    let params = { client: this.configureService.getStudio(), rptname: pushParams.rptname, userid: userID }
    let objData = Object.assign({}, params, obj)
    this.configApiService.pushRequest(objData, (respData) => {
      if (respData == 'SUCCESS') {
       
      }
    })
  }

  //loader
  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Please wait...'
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/drive-service/drive-service.ts